var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMetaMaskIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6476 2.67419L13.1523 8.24105L14.5384 4.95668L20.6476 2.67419Z",
    fill: "#E2761B",
    stroke: "#E2761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.34473 2.67419L10.7798 8.29378L9.46149 4.95668L3.34473 2.67419Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9513 15.5782L15.9551 18.6365L20.2263 19.8117L21.4541 15.646L17.9513 15.5782Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.55371 15.646L3.77405 19.8117L8.04524 18.6365L6.049 15.5782L2.55371 15.646Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.80446 10.4104L6.61426 12.2108L10.8553 12.3991L10.7047 7.84167L7.80446 10.4104Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1881 10.4106L13.2503 7.78909L13.1523 12.3993L17.3859 12.2109L16.1881 10.4106Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.04492 18.6366L10.5911 17.3937L8.39144 15.6761L8.04492 18.6366Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4014 17.3936L15.955 18.6365L15.601 15.6761L13.4014 17.3936Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9541 18.6365L13.4004 17.3936L13.6038 19.0583L13.5812 19.7589L15.9541 18.6365Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.04492 18.6365L10.4178 19.7589L10.4027 19.0583L10.5911 17.3936L8.04492 18.6365Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4554 14.5764L8.33105 13.9511L9.83011 13.2656L10.4554 14.5764Z",
    fill: "#233447",
    stroke: "#233447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5371 14.5764L14.1623 13.2656L15.6689 13.9511L13.5371 14.5764Z",
    fill: "#233447",
    stroke: "#233447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8.04506 18.6365L8.40664 15.5782L6.04883 15.646L8.04506 18.6365Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5928 15.5781L15.9544 18.6365L17.9506 15.6459L15.5928 15.5781Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3859 12.2109L13.1523 12.3993L13.5441 14.5763L14.1693 13.2656L15.6759 13.951L17.3859 12.2109Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33177 13.951L9.83836 13.2656L10.4561 14.5763L10.8553 12.3993L6.61426 12.2109L8.33177 13.951Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M6.61426 12.2109L8.39203 15.6761L8.33177 13.951L6.61426 12.2109Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6769 13.951L15.6016 15.6761L17.3869 12.2109L15.6769 13.951Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8553 12.3993L10.4561 14.5763L10.9532 17.145L11.0662 13.7627L10.8553 12.3993Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1526 12.3992L12.9492 13.7551L13.0396 17.1449L13.5443 14.5762L13.1526 12.3992Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5438 14.5762L13.0391 17.1449L13.4006 17.3935L15.6003 15.676L15.6756 13.9509L13.5438 14.5762Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33105 13.9509L8.39132 15.676L10.5909 17.3935L10.9525 17.1449L10.4553 14.5762L8.33105 13.9509Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5816 19.7589L13.6042 19.0583L13.4159 18.8926H10.576L10.4027 19.0583L10.4178 19.7589L8.04492 18.6365L8.87355 19.3144L10.5534 20.482H13.4385L15.1259 19.3144L15.9545 18.6365L13.5816 19.7589Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4014 17.3936L13.0399 17.145H10.9532L10.5916 17.3936L10.4033 19.0584L10.5766 18.8927H13.4165L13.6048 19.0584L13.4014 17.3936Z",
    fill: "#161616",
    stroke: "#161616",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9645 8.60263L21.6048 5.52919L20.6481 2.67419L13.4014 8.05273L16.1886 10.4105L20.1283 11.5631L21.0021 10.5461L20.6255 10.2749L21.2281 9.72504L20.7611 9.36346L21.3637 8.90395L20.9645 8.60263Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M2.39551 5.52919L3.03581 8.60263L2.62903 8.90395L3.23167 9.36346L2.77216 9.72504L3.37479 10.2749L2.99814 10.5461L3.86443 11.5631L7.80417 10.4105L10.5914 8.05273L3.34466 2.67419L2.39551 5.52919Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1279 11.5631L16.1882 10.4106L17.3859 12.2109L15.6006 15.6761L17.9509 15.646H21.4537L20.1279 11.5631Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M7.80418 10.4106L3.86445 11.5631L2.55371 15.646H6.049L8.39175 15.6761L6.61397 12.2109L7.80418 10.4106Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1521 12.3993L13.4007 8.05283L14.5457 4.95679H9.46094L10.5909 8.05283L10.8545 12.3993L10.9449 13.7703L10.9525 17.1451H13.0391L13.0542 13.7703L13.1521 12.3993Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetaMaskIcon);
export default __webpack_public_path__ + "static/media/MetaMaskIcon.866af0f2eba40f212b2417fe9c865239.svg";
export { ForwardRef as ReactComponent };